import { useNavigate } from 'react-router-dom';
import { useAllocations } from '@saiens/shared/hooks';
import { formatWorkHours } from '@saiens/shared/utils';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { ArrowLeft } from 'lucide-react';

export function AllocationListPage() {
  const navigate = useNavigate();
  const { data: allocations, isLoading } = useAllocations();

  return (
    <div className="mx-auto max-w-lg">
      {/* Header */}
      <div className="sticky top-0 z-10 flex items-center gap-3 bg-white px-4 py-3 shadow-sm">
        <button onClick={() => navigate(-1)} className="rounded-full p-1 hover:bg-gray-100">
          <ArrowLeft className="h-5 w-5" />
        </button>
        <h1 className="text-lg font-semibold">分配紀錄</h1>
      </div>

      <div className="px-4 py-4">
        {isLoading ? (
          <div className="flex h-64 items-center justify-center">
            <LoadingSpinner size="lg" />
          </div>
        ) : !allocations || allocations.length === 0 ? (
          <div className="flex h-40 items-center justify-center text-sm text-gray-400">
            尚無假別分配
          </div>
        ) : (
          <div className="space-y-3">
            {allocations.map((a, idx) => {
              const usageRate =
                a.total_hours > 0 ? (a.used_hours / a.total_hours) * 100 : 0;

              return (
                <div
                  key={`${a.type_id}-${a.validity_end}-${idx}`}
                  className={`rounded-xl bg-white p-4 shadow-sm ${
                    a.is_expired ? 'opacity-50' : ''
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-gray-900">
                      {a.type_name}
                    </h3>
                    {a.is_expired && (
                      <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-500">
                        已過期
                      </span>
                    )}
                  </div>

                  {/* Validity period */}
                  <p className="mt-1 text-xs text-gray-400">
                    {a.validity_start || '—'} ~ {a.validity_end || '—'}
                  </p>

                  {/* Hours info */}
                  <div className="mt-2 flex items-end justify-between text-sm">
                    <span className="text-gray-500">
                      已使用 {formatWorkHours(a.used_hours)} / 共{' '}
                      {formatWorkHours(a.total_hours)}
                    </span>
                    <span className="font-semibold text-violet-600">
                      剩餘 {formatWorkHours(a.remaining_hours)}
                    </span>
                  </div>

                  {/* Progress bar */}
                  <div className="mt-2 h-2 overflow-hidden rounded-full bg-gray-100">
                    <div
                      className={`h-full rounded-full transition-all ${
                        a.is_expired
                          ? 'bg-gray-300'
                          : usageRate >= 90
                            ? 'bg-red-400'
                            : usageRate >= 70
                              ? 'bg-amber-400'
                              : 'bg-violet-400'
                      }`}
                      style={{ width: `${Math.min(usageRate, 100)}%` }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
